import { ItfComparesBtn, ItfComparesChild, ItfComparesColor, ItfComparesData, ItfComparesSpec, ItfComparesLink, ItfComparesItem } from './type';

export const defaultBtn: ItfComparesBtn = {
    ...({} as ItfComparesBtn),
    type: 'fill',
    text: '',
    url: '',
};

export const defaultColor: ItfComparesColor = {
    ...({} as ItfComparesColor),
    btns: [defaultBtn],
    color: 'black',
    img: '',
    label: '',
};

export const defaultSpec: ItfComparesSpec = {
    ...({} as ItfComparesSpec),
    name: '',
    text: '',
};

export const defaultLink: ItfComparesLink = {
    ...({} as ItfComparesLink),
    text: '',
    url: '',
};

export const defaultItem: ItfComparesItem = {
    ...({} as ItfComparesItem),
    label: '',
    name: '',
    text: '',
    type: 'normal',
    img: '',
    btns: [defaultBtn],
    colors: [defaultColor],
    specs: [defaultSpec],
};

export const defaultChild: ItfComparesChild = {
    ...({} as ItfComparesChild),
    tab: '',
    items: [defaultItem],
    links: [defaultLink],
};

export const configData: ItfComparesData = {
    ...({} as ItfComparesData),
    theme: 'white',
    title: '',
    titleColor: 'black',
    children: [defaultChild],
};
